import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  getAmountEstablishment,
  getAmountSections,
  getAmountStudents
} from '../../actions/dashboard';
import Layout from '../../components/Layout/Layout';
import { SubTitleH2, LoadSpinner } from '../../components';
import Card from '../../components/Card';
import { AbilityContext } from '../../config/ability-context';

class Dashboard extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getAmountEstablishment());
    dispatch(getAmountSections());

    dispatch(getAmountStudents());
  }

  render() {
    const { onRequestAmount, amount } = this.props;
    const { context } = this;

    return (
      <Layout>
        <Container fluid>
          <Row>
            <Col role="main">
              {onRequestAmount.establishments &&
                onRequestAmount.students &&
                onRequestAmount.sections && <LoadSpinner />}

              <div className="section">
                <SubTitleH2 text="Vista General" />
                <Row>
                  <Col xs={12} sm={6} lg={4} className="mb-3">
                    <Card
                      title="Establecimientos adheridos"
                      content={String(amount.establishments)}
                      textLink={
                        context.can('create', 'Establishment') && 'Agregar'
                      }
                      href="/create-establishment"
                    />
                  </Col>
                  <Col xs={12} sm={6} lg={4} className="mb-3">
                    <Card
                      title="Cursos adheridos"
                      content={String(amount.sections)}
                      textLink={
                        context.can('create', 'Establishment') && 'Agregar'
                      }
                      href="/establishment-and-courses"
                    />
                  </Col>
                  <Col xs={12} sm={6} lg={4} className="mb-3">
                    <Card
                      title="Estudiantes activos"
                      content={String(amount.students)}
                      textLink="Ver más"
                      href="/students"
                    />
                  </Col>
                </Row>
              </div>
              <div className="section">
                <SubTitleH2 text="Informes de Evaluaciones" />
                <Row>
                  <Col xs={12} sm={6} className="mb-3">
                    <Card title="Establecimientos" />
                  </Col>
                  <Col xs={12} sm={6} className="mb-3">
                    <Card title="Comuna 1 - Tutores de Acompañamiento" />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </Layout>
    );
  }
}

Dashboard.contextType = AbilityContext;
const mapStateToProps = state => {
  const {
    ongoingRequest,
    signedIn,
    user: { role }
  } = state.auth;
  const { amount, ongoingRequest: onRequestAmount } = state.dashboard;
  return {
    ongoingRequest,
    signedIn,
    amount,
    onRequestAmount,
    role
  };
};

export default withRouter(connect(mapStateToProps)(Dashboard));
